import { render, staticRenderFns } from "./Treex.vue?vue&type=template&id=7ea85a1c&scoped=true&"
import script from "./Treex.vue?vue&type=script&lang=js&"
export * from "./Treex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ea85a1c",
  null
  
)

export default component.exports